import React from 'react';

export default function SidebarSkeleton() {
    return (
        <>
            {/* mobile compact button placeholder */}
            <div className="lg:hidden px-4 mt-6 animate-pulse">
                <div className="relative">
                    <div className="w-full flex items-center justify-between gap-3 rounded-2xl bg-blue-50 px-4 py-3 shadow font-bold text-special">
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 flex items-center justify-center rounded-md bg-gray-300" />
                            <div className="h-4 w-24 bg-gray-300 rounded animate-pulse" />
                        </div>

                        <div className="w-5 h-5 bg-gray-300 rounded animate-pulse" />
                    </div>
                </div>
            </div>

            {/* desktop aside placeholder */}
            <aside className="hidden lg:flex flex-col gap-4 shadow w-full lg:w-72 my-10 bg-blue-50 rounded-3xl p-6 lg:h-[calc(100vh-10rem)] animate-pulse">
                <div className="flex flex-col gap-2">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="flex items-center gap-2 rounded-lg px-4 py-2 font-bold">
                            <div className="w-6 h-6 bg-gray-300 rounded-md" />
                            <div className="h-4 w-28 bg-gray-300 rounded animate-pulse" />
                        </div>
                    ))}
                </div>

                <div className="mt-auto">
                    <div className="flex items-center gap-2 text-special rounded-lg px-4 py-2 font-bold w-full">
                        <div className="w-6 h-6 bg-gray-300 rounded" />
                        <div className="h-4 w-24 bg-gray-300 rounded animate-pulse" />
                    </div>
                </div>
            </aside>
        </>
    );
}
